import Repository from './Repository'
import TokenService from '../helpers/token'
const resource = `${Repository.defaults.baseURL}/tutor-test`
export default {
    async get(id) {
        const response = await Repository.get(`${resource}/${id}/over`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getMath() {
        const response = await Repository.get(`${resource}/grade`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getListObject() {
        const response = await Repository.get(`${resource}/subject`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async CreateLinkTest(contactTutor) {
        const response = await Repository.post(`${resource}`, contactTutor, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getListTutor(params) {
        const response = await Repository.get(`${resource}`, {
            params,
            headers: TokenService.getHeader(),
        })

        return response
    },
    async getAllStatus() {
        const response = await Repository.get(`${resource}/status/list`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getListUser() {
        const response = await Repository.get(`${resource}/list-user?keyword`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async createInterview(tutorPracticeId, body) {
        const response = await Repository.post(`${resource}/practice/${tutorPracticeId}/interview`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async createComment(tutorPracticeId, body) {
        const response = await Repository.post(`${resource}/practice/${tutorPracticeId}/comment`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getDetailComment(tutorPracticeId) {
        const response = await Repository.get(`${resource}/practice/${tutorPracticeId}/comment`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getStatistics(params) {
        const response = await Repository.get(`${resource}/statistics`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async updateDateTime(id, params) {
        const response = await Repository.put(`${resource}/practice/${id}/appointment`, params, {
            headers: TokenService.getHeader(),
        })
        return response
    },

}